import React, { Component } from 'react';
import Loading from '../../Loading.js'
import Modal from 'react-modal';
import ControlMessageNew from './ControlMessageNew.js';
import { getTranslation } from '../../../Utilities/GetTranslation.js';
import { getProjectFiche } from '../../../Api/ExtranetActions.js';
import { isEmpty, getJsonDate, getDateString } from '../../../Utilities/JsonFunctions.js';
import { getCreateMsgTitle } from '../../../Utilities/SnsExtranetFunctions.js';

declare var globalSns;
declare var $;

class ExtranetProjectsFiche extends Component {
    constructor(props) {
        super(props);

        this.state = {}

        this.onSubNavigate = this.onSubNavigate.bind(this);
        this.openMessageBox = this.openMessageBox.bind(this);
        this.closeMessageBox = this.closeMessageBox.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getProjectFiche(this.props.id, globalSns.languageId, (data) => {
            this.setState({
                project: data
            });
        });
    }

    onSubNavigate(pageId) {
        this.props.onSubNavigate(pageId);
    }

    openMessageBox() {
        this.setState({openMessageBox: true});
    }

    closeMessageBox() {
        this.setState({openMessageBox: false});
    }

    render() {
        if (this.state.project == null) {
            return (
                <Loading/>
            );
        }

        return (
            <div className="container-fluid">
                <div className="row equalheights">
                    <div className="col-md-6">
                        <div className="ebadge">
                            <h2>{getTranslation("sns.general.extranet.projectinfo")}</h2>
                            <div className="EditingFormTable table">
                                <div className="tr">
                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.projectinfo.title")}</div>
                                    <div className="EditingFormValueCell td"><p className="form-control-static">{this.state.project.title}</p></div>
                                </div>
                                <div className="tr">
                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.projectinfo.nrprofiles")}</div>
                                    <div className="EditingFormValueCell td"><p className="form-control-static">{this.state.project.nrProfiles}</p></div>
                                </div>
                                <div className="tr">
                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.projectinfo.services")}</div>
                                    <div className="EditingFormValueCell td">
                                        <p className="form-control-static">
                                            {
                                                this.state.project.services.map((service) =>
                                                    <span key={service}>{service}<br/></span>
                                                )
                                            }
                                        </p>
                                    </div>
                                </div>
                                <div className="tr">
                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.projectinfo.prl1")}</div>
                                    <div className="EditingFormValueCell td"><p className="form-control-static">{this.state.project.prl1}</p></div>
                                </div>
                                {
                                    !isEmpty(this.state.project.prl2) ?
                                        <div className="tr">
                                            <div className="FieldLabel td">{getTranslation("sns.general.extranet.projectinfo.prl2")}</div>
                                            <div className="EditingFormValueCell td"><p className="form-control-static">{this.state.project.prl2}</p></div>
                                        </div> : ""
                                }
                                {
                                    !isEmpty(this.state.project.cont1) ?
                                        <div className="tr">
                                            <div className="FieldLabel td">{getTranslation("sns.general.extranet.projectinfo.cont")} 1</div>
                                            <div className="EditingFormValueCell td"><p className="form-control-static">{this.state.project.cont1}</p></div>
                                        </div> : ""
                                }
                                {
                                    !isEmpty(this.state.project.cont2) ?
                                        <div className="tr">
                                            <div className="FieldLabel td">{getTranslation("sns.general.extranet.projectinfo.cont")} 2</div>
                                            <div className="EditingFormValueCell td"><p className="form-control-static">{this.state.project.cont2}</p></div>
                                        </div> : ""
                                }
                                {
                                    !isEmpty(this.state.project.cont3) ?
                                        <div className="tr">
                                            <div className="FieldLabel td">{getTranslation("sns.general.extranet.projectinfo.cont")} 3</div>
                                            <div className="EditingFormValueCell td"><p className="form-control-static">{this.state.project.cont3}</p></div>
                                        </div> : ""
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="ebadge">
                            <h2>{getTranslation("sns.general.extranet.projectstatus")}</h2>
                            <div className="EditingFormTable table">
                                <div className="tr">
                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.projectstatus.nrcandidates")}</div>
                                    <div className="EditingFormValueCell td">
                                        <p className="form-control-static">
                                            <a className="subcatlink" onClick={(e) => this.props.onSubNavigate("extranetProjectsCandidates")}><span className="alignnumeric">{this.state.project.nrCandidates}</span> <i className="fa fa-id-card-o" aria-hidden="true"></i></a>
                                        </p>
                                    </div>
                                </div>
                                <div className="tr">
                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.projectstatus.nrdocuments")}</div>
                                    <div className="EditingFormValueCell td">
                                        <p className="form-control-static">
                                            <a className="subcatlink" onClick={(e) => this.props.onSubNavigate("extranetProjectsDocuments")}><span className="alignnumeric">{this.state.project.nrDocuments}</span> <i className="fa fa-paperclip" aria-hidden="true"></i></a>
                                        </p>
                                    </div>
                                </div>
                                <div className="tr">
                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.projectstatus.nrmessages")}</div>
                                    <div className="EditingFormValueCell td">
                                        <p className="form-control-static">
                                            <a className="subcatlink" onClick={(e) => this.props.onSubNavigate("extranetProjectsMessages")}><span className="alignnumeric">{this.state.project.nrMessages}</span> <i className="fa fa-envelope-o" aria-hidden="true"></i></a>
                                        </p>
                                    </div>
                                </div>
                                <div className="tr">
                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.projectstatus.status")}</div>
                                    <div className="EditingFormValueCell td">
                                        <p className="form-control-static">
                                            {                                                
                                                this.state.project.mainState ? 
                                                    <span className="text-danger">{this.state.project.status}</span> :
                                                    <span className="text-success">{this.state.project.status}</span>
                                            }
                                        </p>
                                    </div>
                                </div>
                                <div className="tr">
                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.projectstatus.datstart")}</div>
                                    <div className="EditingFormValueCell td"><p className="form-control-static">{getDateString(getJsonDate(this.state.project.datStart))}</p></div>
                                </div>
                                <div className="tr">
                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.projectstatus.datend")}</div>
                                    <div className="EditingFormValueCell td"><p className="form-control-static">{getDateString(getJsonDate(this.state.project.datEnd))}</p></div>
                                </div>                              
                            </div>
                            <h2>{getTranslation("sns.general.extranet.publication")}</h2>
                            <div className="EditingFormTable table">
                                <div className="tr">
                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.publication.status")}</div>
                                    <div className="EditingFormValueCell td">
                                        <p className="form-control-static">
                                            {
                                                this.state.project.isPublished && !this.state.project.mainState ? 
                                                    <span className="text-success">
                                                        {getTranslation("sns.webparts.applications.open")}&nbsp;&nbsp;&nbsp;
                                                        <a className="subcatlink" href={"/" + globalSns.cultureAlias + "/jobs/" + this.state.project.id} target="_blank">
                                                            <i className="fa fa-search" aria-hidden="true"></i>
                                                        </a>                                                        
                                                    </span> :
                                                    <span className="text-danger">{getTranslation("sns.webparts.applications.closed")}</span>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div> 
                            <div className="feedbackButton">
                                <button type="button" className="FormButton btn btn-primary btn-sm" onClick={this.openMessageBox}>
                                    <i className="fa fa-pencil" aria-hidden="true"></i>{getCreateMsgTitle(null, this.props.id)}
                                </button>
                            </div>                            
                        </div>                       
                    </div>
                </div>
                <Modal
                    isOpen={this.state.openMessageBox}
                    onRequestClose={this.closeMessageBox}
                    className="ReactModal"
                    overlayClassName="ReactModalOverlay"                    
                >
                    <ControlMessageNew 
                        projectId={this.props.id}
                        projectName={this.props.title}
                        onRequestClose={this.closeMessageBox} />
                </Modal>                 
            </div>
        );
    }
}

export default ExtranetProjectsFiche;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ExtranetProjectsFiche.js